import Configuration from "./Configuration";
import Main from "./Main";
import "./App.css";

const App = () => (
  <Configuration>
    <Main />
  </Configuration>
);

export default App;
